import { render, staticRenderFns } from "./Listado-simple.vue?vue&type=template&id=2cc3e14a&scoped=true&lang=pug"
import script from "./Listado-simple.vue?vue&type=script&lang=js"
export * from "./Listado-simple.vue?vue&type=script&lang=js"
import style0 from "./Listado-simple.vue?vue&type=style&index=0&id=2cc3e14a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc3e14a",
  null
  
)

export default component.exports